export default "__VITE_ASSET__H_DNYUJG__"